<template>
  <div class="hello">
    <h1>欢迎使用评比打分系统</h1>
    <p>管理员请<a @click="$router.push('/auth/login')">点击此处</a>登录，评委请扫码或通过分享的链接登录</p>
  </div>
</template>
<script>
export default {
  name: 'HelloWorld',
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
